import axiosInstance from './axiosInstance';

const buildQueryParams = (period, customDates) => {
  let params = `period=${period}`;
  if (period === 'custom' && customDates?.startDate && customDates?.endDate) {
    params += `&start_date=${customDates.startDate}&end_date=${customDates.endDate}`;
  }
  return params;
};

export const dashboardService = {
  getOverview: (period = 'week', customDates = null) =>
    axiosInstance.get(`/api/dashboard/overview?${buildQueryParams(period, customDates)}`),

  getAcquisition: (period = 'week', customDates = null) =>
    axiosInstance.get(`/api/dashboard/acquisition?${buildQueryParams(period, customDates)}`),

  getRetention: (period = 'week', customDates = null) =>
    axiosInstance.get(`/api/dashboard/retention?${buildQueryParams(period, customDates)}`),

  getValue: (period = 'week', customDates = null) =>
    axiosInstance.get(`/api/dashboard/value?${buildQueryParams(period, customDates)}`),

  getRestaurants: (period = 'week', customDates = null) =>
    axiosInstance.get(`/api/dashboard/restaurants?${buildQueryParams(period, customDates)}`),

  getB2B: (period = 'week', customDates = null) =>
    axiosInstance.get(`/api/dashboard/b2b?${buildQueryParams(period, customDates)}`),

  getEtablissementDetails: (etablissementId, period = 'week') =>
    axiosInstance.get(`/api/dashboard/etablissement/${etablissementId}?period=${period}`).then(res => res.data),

  getAcquisitionCohort: (period = 'week', customDates = null) =>
    axiosInstance.get(`/api/dashboard/acquisition-cohort?${buildQueryParams(period, customDates)}`),

  getMonthlyCohort: () =>
    axiosInstance.get('/api/dashboard/monthly-cohort'),
};
